import { graphql } from "@/gql";

export const USERS_QUERY = graphql(`
  query USERS_QUERY {
    adminUsers {
      edges {
        node {
          id
          fullName
          applicationRole
          createdAt
          lastActiveAt
          isEnabled
          phoneNumber
          emailAddress
        }
      }
    }
  }
`);
